import React from 'react';
import { TrendingUp, Users, DollarSign, CheckCircle } from 'lucide-react';
export function AnalyticsDashboard() {
  return <div className="relative w-full max-w-sm md:max-w-lg mx-auto lg:mx-0 group" data-id="element-8">
      {/* Background Glow */}
      <div className="absolute inset-0 bg-blue-500/15 blur-[60px] md:blur-[80px] rounded-full -z-10" data-id="element-9" />

      {/* Main Dashboard Card */}
      <div className="glass-panel rounded-2xl md:rounded-3xl p-4 sm:p-5 md:p-8 relative transform transition-all duration-500 md:hover:rotate-1 md:hover:scale-[1.02] border border-white/10 shadow-2xl bg-[#0a0a0f]/60 backdrop-blur-xl" data-id="element-10">
        {/* Header */}
        <div className="flex justify-between items-center mb-5 md:mb-8 border-b border-white/5 pb-3 md:pb-4" data-id="element-11">
          <div data-id="element-12">
            <h3 className="text-sm md:text-base font-semibold text-white tracking-[-0.01em]" data-id="element-13">
              Channel Analytics
            </h3>
            <p className="label-caps text-[9px] md:text-[10px] text-gray-500 mt-0.5" data-id="element-14">
              Last 28 days
            </p>
          </div>
          <div className="flex items-center gap-1 text-green-400 bg-green-400/10 px-1.5 md:px-2 py-0.5 md:py-1 rounded-full text-[10px] md:text-xs font-bold tabular-nums" data-id="element-15">
            <TrendingUp className="w-2.5 h-2.5 md:w-3 md:h-3" data-id="element-16" />
            <span data-id="element-17">+127%</span>
          </div>
        </div>

        {/* Main Stat */}
        <div className="mb-4 md:mb-6" data-id="element-18">
          <p className="label-caps text-[9px] md:text-[10px] text-gray-500 mb-1.5" data-id="element-19">
            Estimated Revenue
          </p>
          <div className="flex items-baseline gap-2" data-id="element-20">
            <span className="text-3xl md:text-4xl font-black tabular-nums tracking-[-0.03em] text-transparent bg-clip-text bg-gradient-to-r from-white via-blue-100 to-white" data-id="element-21">
              $8,250
            </span>
          </div>
        </div>

        {/* Chart Area */}
        <div className="h-20 md:h-28 w-full mb-4 md:mb-6 relative" data-id="element-22">
          {/* Grid lines */}
          <div className="absolute inset-0 flex flex-col justify-between opacity-10" data-id="element-23">
            <div className="w-full h-px bg-white" data-id="element-24"></div>
            <div className="w-full h-px bg-white" data-id="element-25"></div>
            <div className="w-full h-px bg-white" data-id="element-26"></div>
            <div className="w-full h-px bg-white" data-id="element-27"></div>
          </div>

          {/* SVG Chart Line */}
          <svg className="w-full h-full overflow-visible" viewBox="0 0 400 128" preserveAspectRatio="none" data-id="element-28">
            <defs data-id="element-29">
              <linearGradient id="lineGradient" x1="0%" y1="0%" x2="100%" y2="0%" data-id="element-30">
                <stop offset="0%" stopColor="#3b82f6" data-id="element-31" />
                <stop offset="100%" stopColor="#a855f7" data-id="element-32" />
              </linearGradient>
              <linearGradient id="areaGradient" x1="0%" y1="0%" x2="0%" y2="100%" data-id="element-33">
                <stop offset="0%" stopColor="#3b82f6" stopOpacity="0.2" data-id="element-34" />
                <stop offset="100%" stopColor="#3b82f6" stopOpacity="0" data-id="element-35" />
              </linearGradient>
            </defs>
            <path d="M0,128 C40,120 80,100 120,90 C160,80 200,60 240,40 C280,20 320,10 400,5 L400,128 L0,128 Z" fill="url(#areaGradient)" data-id="element-36" />
            <path d="M0,128 C40,120 80,100 120,90 C160,80 200,60 240,40 C280,20 320,10 400,5" fill="none" stroke="url(#lineGradient)" strokeWidth="4" strokeLinecap="round" className="drop-shadow-[0_0_10px_rgba(59,130,246,0.5)]" data-id="element-37" />
            <circle cx="120" cy="90" r="4" fill="#fff" className="animate-pulse" data-id="element-38" />
            <circle cx="240" cy="40" r="4" fill="#fff" className="animate-pulse" data-id="element-39" />
            <circle cx="400" cy="5" r="6" fill="#fff" stroke="#a855f7" strokeWidth="2" className="animate-pulse" data-id="element-40" />
          </svg>
        </div>

        {/* Mini Stats Row */}
        <div className="grid grid-cols-3 gap-2 md:gap-4" data-id="element-41">
          <div className="bg-white/5 rounded-lg md:rounded-xl p-2 md:p-3 border border-white/5" data-id="element-42">
            <div className="flex items-center gap-1 text-gray-500 label-caps text-[8px] md:text-[9px] mb-0.5 md:mb-1" data-id="element-43">
              <Users className="w-2.5 h-2.5 md:w-3 md:h-3" data-id="element-44" />
              <span data-id="element-45">Subs</span>
            </div>
            <p className="text-sm md:text-lg font-extrabold text-white tabular-nums tracking-tight" data-id="element-46">
              2.4K
            </p>
          </div>
          <div className="bg-white/5 rounded-lg md:rounded-xl p-2 md:p-3 border border-white/5" data-id="element-47">
            <div className="flex items-center gap-1 text-gray-500 label-caps text-[8px] md:text-[9px] mb-0.5 md:mb-1" data-id="element-48">
              <TrendingUp className="w-2.5 h-2.5 md:w-3 md:h-3" data-id="element-49" />
              <span data-id="element-50">Views</span>
            </div>
            <p className="text-sm md:text-lg font-extrabold text-white tabular-nums tracking-tight" data-id="element-51">
              115K
            </p>
          </div>
          <div className="bg-white/5 rounded-lg md:rounded-xl p-2 md:p-3 border border-white/5" data-id="element-52">
            <div className="flex items-center gap-1 text-gray-500 label-caps text-[8px] md:text-[9px] mb-0.5 md:mb-1" data-id="element-53">
              <DollarSign className="w-2.5 h-2.5 md:w-3 md:h-3" data-id="element-54" />
              <span data-id="element-55">RPM</span>
            </div>
            <p className="text-sm md:text-lg font-extrabold text-white tabular-nums tracking-tight" data-id="element-56">
              $7.12
            </p>
          </div>
        </div>

        {/* Floating Elements - hidden on mobile to prevent clipping */}
        <div className="hidden md:flex absolute -top-6 -right-6 bg-[#0a0a0f] border border-white/10 p-3 rounded-xl shadow-xl animate-float items-center gap-3 z-20" data-id="element-57">
          <div className="bg-green-500/20 p-1.5 rounded-full" data-id="element-58">
            <CheckCircle className="w-4 h-4 text-green-500" data-id="element-59" />
          </div>
          <div data-id="element-60">
            <p className="text-xs font-bold text-white tracking-tight" data-id="element-61">
              Monetized!
            </p>
            <p className="text-[9px] text-gray-500 font-medium" data-id="element-62">Just now</p>
          </div>
        </div>

        <div className="hidden md:flex absolute -bottom-6 -left-6 bg-[#0a0a0f] border border-white/10 p-3 rounded-xl shadow-xl animate-float-delayed items-center gap-3 z-20" data-id="element-63">
          <div className="bg-blue-500/20 p-1.5 rounded-full" data-id="element-64">
            <DollarSign className="w-4 h-4 text-blue-500" data-id="element-65" />
          </div>
          <div data-id="element-66">
            <p className="text-xs font-bold text-white tabular-nums tracking-tight" data-id="element-67">
              +$1,200
            </p>
            <p className="text-[9px] text-gray-500 font-medium" data-id="element-68">
              Today's revenue
            </p>
          </div>
        </div>
      </div>
    </div>;
}